import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { trackSignup } from "@/lib/analytics";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useAuth();
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        (async () => {
            const hash = window.location.hash || "";
            const m = hash.match(/session_id=([^&]+)/);
            if (!m) {
                nav("/login", { replace: true });
                return;
            }
            const session_id = decodeURIComponent(m[1]);
            try {
                const { data } = await api.post("/auth/google/session", { session_id });
                setUser(data);
                // Fire the Google Ads signup conversion once, only on
                // first-time Google sign-up (backend flags is_new_user).
                if (data.is_new_user) trackSignup({ transactionId: data.id });
                // Wipe the URL fragment so reloads don't replay it
                window.history.replaceState({}, "", window.location.pathname);
                // First time logging in via google? send to onboarding if no vessels
                try {
                    const { data: vs } = await api.get("/vessels");
                    if (!vs || vs.length === 0) nav("/onboarding", { replace: true });
                    else nav("/app", { replace: true });
                } catch (e) {
                    console.warn("[auth-callback] vessel fetch failed, going to /app anyway", e);
                    nav("/app", { replace: true });
                }
            } catch (e) {
                console.warn("[auth-callback] google session exchange failed", e);
                nav("/login?error=oauth", { replace: true });
            }
        })();
    }, [nav, setUser]);

    return (
        <div
            data-testid="auth-callback"
            style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--bm-text-muted)", fontFamily: "var(--bm-font-display)", fontStyle: "italic", fontSize: 20 }}
        >
            <span className="bm-pulse">⚓ checking your papers…</span>
        </div>
    );
}
